var React = require('react');

function FloorPlan (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19 19.5V0.5H0V19.5H19ZM2.375 2.875H7.125V5.25H9.5V2.875H16.625V8.8125H11.875V11.1875H16.625V17.125H9.5V14.75H7.125V17.125H2.375V11.1875H7.125V12.375H9.5V7.625H7.125V8.8125H2.375V2.875Z","fill":"currentColor"}));
}

FloorPlan.defaultProps = {"preserveAspectRatio":"xMinYMin meet","viewBox":"0 0 19 20","fill":"none"};

module.exports = FloorPlan;

FloorPlan.default = FloorPlan;
